/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
import React, { useState, useContext, useEffect } from 'react';
import TopHeader from '../../components/TopHeader';
import { motion } from 'framer-motion';
import { useDropzone } from 'react-dropzone';
import { useSelector } from 'react-redux';
import GlobalContext from '../../components/Context/GloablContext';
import TextArea from '../../components/TextArea';
import AnimatedModel from '../../components/Animation/AnimatedModel';
import S3UploadHookFileTRansfer from '../../CommonMethods/s3uploadHookFiletransfer';
import { useTransferFileMutation ,useActivityHistoryFileTransferMutation, useGetHelpGuideProviderQuery} from '../../slices/patientSlice';
import Loader from '../../components/Loader';
import HelpGuideModal from '../../components/HelpGuideModal';
import CustomOverLay from '../../components/CustomOverLay';
import { dataService } from '../../services/data.services';

export default function ManageUploadFile() {
    const [transferFile] = useTransferFileMutation()
    const [activityhistory] = useActivityHistoryFileTransferMutation()
    const [patientErrorMessage, setPatientErrorMessage] = useState('');
    const [patientErrorFileName, setPatientErrorFileName] = useState('');
    const [fileName, setFileName] = useState('');
    const [cancelupload, setCancelupload] = useState(false); 
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);
    const [proceedImport, setProceedImport] = useState(false);
    const [fileImportLoading, setFileImportLoading] = useState(false);
    const [temporaryFile, setTemporaryFile] = useState(null);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const [uploadSuccess , setUploadSuccess] =  useState(false)
    const [configloading,setConfigLoading] = useState(false);
    const [fileNameForActivity, setFileNameForActivity] = useState('')
    const [note, setNote] = useState('');
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
    const [loading, setLoading] = useState(false);
    const fileSizeSystemConfig = useSelector(state => state.systemConfigData.globalVariables.maximum_file_size)

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    useEffect(() => {
        if (userType === 'monitor-user') {
            setQueryParamsorg('type=monitor-upload-file');
        } else {
            setQueryParamsorg('type=provider-upload-file');
        }
    }, [userType]);
          
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    const onDropPatient = (acceptedFiles) => {
        const file = acceptedFiles[0];
        handleFileUpload(file, setPatientErrorMessage, setPatientErrorFileName);
    };

    const handleFileUpload = async (file, setErrorMessage, setErrorFileName) => {
        const maxSize = fileSizeSystemConfig * 1024 * 1024;
        let fileNameWithType = `${file.name}`;
        setFileNameForActivity(fileNameWithType);
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const restrictedExtensions = ['sh', 'exec', 'mp3', 'mp4', 'zip'];
        const restrictedTypes = [
            'audio/',
            'video/',
            'application/x-sh',
            'application/x-msdownload',
            'application/zip',
            'application/x-zip-compressed'
        ];

        // Check if no file is selected
        if (!file) {
            setErrorMessage('No file selected.');
            return;
        }

        // Check for restricted file extensions or types
        if (restrictedExtensions.includes(fileExtension) ||
            restrictedTypes.some(type => file.type.startsWith(type))) {
            setErrorFileName(fileNameWithType);
            setErrorMessage('The selected file format is not allowed.');
            setTemporaryFile(null); // Reset the temporary file

            // Log the activity for invalid file format
            await activityhistory({
                type: 'Rejected',
                field: 'File Upload',
                info: `File type error: ${fileExtension}`,  // Log the invalid file extension
                value: fileNameWithType,  // File name
            });
            return;
        }

        // Check for file size
        const fileSizeMB = (file.size / 1_000_000).toFixed(1);
        if (file.size > maxSize) {
            setErrorFileName(fileNameWithType);
            setErrorMessage(`File size exceeds the allowed limit.`);
            setTemporaryFile(null); // Reset the temporary file

            // Log the activity for file size exceeding limit
            await activityhistory({
                type: 'Rejected',
                field: 'File Upload',
                info: `File size exceeds the allowed limit: ${fileSizeMB} MB`,  // Log the file size
                value: fileNameWithType,  // File name
            });
            return;
        }

        // If the file is valid, proceed
        setTemporaryFile(file);
        setFileName(file.name);
        // setProceedImport(true);
        setPatientErrorMessage('');
        setShowNoteModal(false);
    };



    function handleEditOnChangeInput(id, value) {

        // Throttle the function to limit the frequency of updates
        const throttledHandleEditOnChangeInput = ((id, value) => {
            setNote(value);
        });

        // Call the throttled function with the provided arguments
        throttledHandleEditOnChangeInput(id, value);
    }

    const truncateFilename = (filename, maxLength) => {
        if (filename.length <= maxLength) return filename;
        const separator = '...';
        const charsToShow = maxLength - separator.length;
        const frontChars = Math.ceil(charsToShow / 2);
        const backChars = Math.floor(charsToShow / 2);
        return filename.substr(0, frontChars) + separator + filename.substr(filename.length - backChars);
    };

    const handleUploadClick = () => {
        setShowNoteModal(true); // Show modal to add a note
        setUploadSuccess(true); 
        setFileName('')
    };

    useEffect(() => {
        const fetchData = async () => {
            setUploadSuccess(true)
            setConfigLoading(true);
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                setSystemConfigdata(response?.data?.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
            setConfigLoading(false);
        };
        fetchData();
    }, []);

    const handleConfirmUpload = async () => {
        
        setShowNoteModal(true);
        setLoading(true)
        try {
            const key = `${temporaryFile.name}`;
            let body = {
                "file_name": temporaryFile.name,
                "more_info": note,
            }

            await S3UploadHookFileTRansfer(temporaryFile, key);
            const response = await transferFile(body)

            if (response.data && response.data.message) {
                setLoading(false)
                setShowNoteModal(false)
                setToastmessage("File uploaded successfully");
                await activityhistory({
                    type: 'Completed',
                    field: 'File Upload',
                    info: `-`,  // Log the deatils
                    value: fileNameForActivity,  // File name
                });
                setTemporaryFile(null); // Reset the temporary file
                setNote(''); // Reset the note
                setFileName(''); // Reset the file name
                // setProceedImport(false);
            } else {
                setLoading(false)
                setPatientErrorFileName(temporaryFile.name);
                setShowNoteModal(false)
                setPatientErrorMessage('Upload failed. Please try again.');
            }
        } catch (error) {
            console.error('Error during file upload:', error);
            setLoading(false)
            setShowNoteModal(false)
            setPatientErrorMessage('An error occurred while uploading. Please try again.');
        } finally {
            setFileImportLoading(false);
        }
    };

    const handleCancelUpload = () => {
        activityhistory({
            type: 'Aborted',
            field: 'File Upload',
            info: '-',  // Custom info for Go Back action
            value: fileNameForActivity,  // The file name that caused the error
        });
        setShowNoteModal(false); // Close the modal
        setTemporaryFile(null); // Reset the temporary file
        setFileName(''); // Reset the file name
        setNote(''); // Optionally reset the note
        setPatientErrorMessage(''); // Clear the error message
        setPatientErrorFileName(''); // Clear the error file name
    };

    const restrictedFormats = ['sh', 'exec', 'mp3', 'mp4', 'zip'];

    const { getRootProps: getPatientRootProps, getInputProps: getPatientInputProps } = useDropzone({
        onDrop: onDropPatient,
        accept: '.csv', // Accept only CSV files as defined
        maxSize: 1 * 1024 * 1024 * 1024, // 1GB in bytes
        onDropRejected: (fileRejections) => {
            const fileRejection = fileRejections[0];
            const file = fileRejection.file;
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (file.size > 1 * 1024 * 1024 * 1024) {
                setPatientErrorMessage('File size exceeds the allowed limit. Max: 1,000 MB');
            } else if (restrictedFormats.includes(fileExtension)) {
                setPatientErrorMessage(`File type error: Files with the following extensions are not allowed: ${restrictedFormats.join(', ')}`);
            } else if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
                setPatientErrorMessage('File type error: Upload a CSV');
            }
            setTemporaryFile(null); // Reset the temporary file
        },
    });


    const handleGoBack = (cancelupload) => {
        if (cancelupload) {
            activityhistory({
                type: 'Aborted',
                field: 'File Upload',
                info: '-',  // Custom info for Go Back action
                value: temporaryFile.name,  // The file name that caused the error
            });
        }
    
        setPatientErrorFileName('');
        setPatientErrorMessage('');
        setFileName(''); // Reset the file name on go back
    };
    return (
        <div className={`pt-[95px] px-[30px] bg-[#F9F3F5] h-full w-full overflow-x-hidden`}>
            <TopHeader title={"Upload File"} />
            {configloading?<div className='h-[95%] p-6 relative'><CustomOverLay Active text={'Loading Upload File'} classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col h-full w-full items-center justify-center`}/></div>:<>
                <div className={`rounded-lg h-[calc(100vh-110px)] bg-white`}>
                    <motion.div className="mt-1" animate={{ x: 0 }} initial={{ x: -10 }} transition={{ duration: 0.5 }}>
                        <div className='mx-7'>
                            <p className='pt-5 text-center text-[24px] leading-[32px] font-normal text-[000000]'>Please attach the file that you wish to transmit</p>
                            <div className='flex justify-between items-center mt-9'>
                                <p className='text-xs font-semibold text-[#000000]'>{`Note : Maximum file size ${fileSizeSystemConfig}MB`}</p>
                                <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                </span> 
                            </div>
                            <div className='mt-4'>
                                {!fileImportLoading && !fileName && uploadSuccess && (
                                    <><div className='h-[221px] border bg-[#F9FCFC] flex justify-between items-center border-dashed border-[#CB6A97] rounded-[6px]'>
                                        {!patientErrorMessage ? (
                                            <>
                                                <div className='flex cursor-pointer justify-center items-center w-[50%]'>
                                                    <div {...getPatientRootProps()} className='flex flex-col items-center w-full h-full'>
                                                        <input {...getPatientInputProps()} />
                                                        <img loading="lazy" decoding='async' src="/images/uploadicon-import.svg" alt="uploadicon" />
                                                        <p className='pt-5 text-center text-[14px] leading-[19px] font-semibold text-[#416072]'>
                                                        Drag and drop your file here
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className='text-[12px] leading-[16px] font-normal relative'>
                                                or <span className='oraboveline'></span>
                                                </p>
                                                <div className='flex justify-center items-center w-[50%]'>
                                                    <label htmlFor="fileUpload" className='w-[162px] xl:w-[250px]'>
                                                        <input
                                                            id="fileUpload"
                                                            type="file"
                                                            onChange={(e) => onDropPatient(e.target.files)}
                                                            className='opacity-0 absolute z-10 cursor-pointer w-[162px] xl:w-[250px] h-[50px]' />
                                                        <div className='px-4 py-2.5 border border-[#972E4C] rounded-[16px] cursor-pointer text-center text-lg font-semibold text-[#972E4C]'>
                                                        Browse File
                                                        </div>
                                                    </label>
                                                </div>
                                            </>
                                        ) : (
                                            <div className=' bg-[#F9FCFC] flex flex-col  justify-center items-center mx-auto rounded-[6px]'>
                                                <img loading='lazy' decoding='async' src="/images/file-error.svg" alt="file-error" />
                                                {/* <p className='pt-2 text-center text-[14px] leading-[19px] font-semibold text-[#972E4C]'>
                                                {patientErrorMessage || `File: ${patientErrorFileName}`}
                                            </p> */}
                                                <div className='rounded-[6px] bg-[#F8EEF1] relative text-[13px] text-[#416072] leading-[16px] min-w-[215px] max-w-fit mt-3 py-[8px] pl-[10px] pr-[40px]'>
                                                    <span title={patientErrorFileName}>{truncateFilename(patientErrorFileName, 25)}</span>
                                                    <img className='absolute top-[4px] cursor-pointer right-[10px]' onClick={() => handleGoBack(cancelupload)}  src="/images/closeiconimport.svg" alt="closeicon" />
                                                </div>
                                                <p className='text-[#C81720] text-[15px] leading-[16px] mt-3 text-center'>{patientErrorMessage}</p>
                                            </div>
                                        )}

                                    </div>
                                    {patientErrorMessage &&
                                        <div className='flex justify-center'>
                                            <button onClick={() => handleGoBack(cancelupload)} 
                                                className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[200px] bg-[#972E4C]
                                             hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] mx-auto`}>
                                                Go Back
                                            </button>
                                        </div>
                                    }
                                    </>
                                )}
                                {fileName && (
                                    <>
                                        <div className='h-[221px] border bg-[#F9FCFC] flex justify-center flex-col items-center border-dotted border-[#CB6A97] rounded-[6px]'>
                                            <img src="/images/uploadicon-import.svg" alt="uploadicon" />
                                            <div className='rounded-[6px] bg-[#F8EEF1] relative text-[13px] text-[#416072] leading-[16px] min-w-[215px] max-w-fit mt-3 py-[8px] pl-[10px] pr-[40px]'>
                                                <span title={fileName}>{truncateFilename(fileName, 25)}</span>
                                                <img loading='lazy' decoding='async' className='absolute top-[4px] cursor-pointer right-[10px]' onClick={ handleGoBack} src="/images/closeiconimport.svg" alt="closeicon" />
                                            </div>


                                        </div>
                                        <div className='flex justify-center'>
                                            <button onClick={handleUploadClick}
                                                data-testid="continue_upload"
                                                className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[200px] bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] mx-auto`}>
                                            Upload
                                            </button>
                                        </div>
                                    </>)}
                                {showNoteModal &&
                                <AnimatedModel key="edit-model"
                                    Children={
                                        <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{ display: "block" }}>
                                            <div data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                                <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                                                    <div className="flex justify-between pb-[16px] ">
                                                        <h1 className='text-2xl font-normal text-[#000]'>Append Comment</h1>
                                                        <img
                                                            loading='lazy'
                                                            decoding='async'
                                                            alt='img'
                                                            onClick={handleCancelUpload}
                                                            src='/images/close_icon.svg'
                                                            className='cursor-pointer' />
                                                    </div>
                                                    <div className='pl-4 2xl:pl-[20px]  border rounded-[8px] border-[#C5C9DA] pr-4 py-2'>
                                                        <TextArea
                                                            PatientNotes={true}
                                                            label={''}
                                                            htmlFor={'administrative_Notes'}
                                                            id={'administrative_Notes'}
                                                            placeholder={'Type note here...'}
                                                            handleOnChangeInput={handleEditOnChangeInput}
                                                            handleOnCLickActivate={''}
                                                            loadingActivation={false}

                                                        />

                                                    </div>

                                                    <div className='px-2.5 flex justify-between  pt-3'>
                                                        <button onClick={handleCancelUpload} disabled={loading} className='px-4 py-2.5 text-lg font-semibold text-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
                                                        border border-[#972E4C] disabled:cursor-not-allowed'>
                                                            No
                                                        </button>
                                                        <button
                                                            disabled={note.trim() === "" || note === undefined || loading}
                                                            id={'add_admin'}
                                                            onClick={handleConfirmUpload}
                                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                            {!loading ? <span>Yes</span> : <span><Loader /></span>}
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    }
                                />
                                }
                            </div>
                        </div>
                    </motion.div>
                </div>
            </>}
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
        </div>
    );
}

